import React from 'react';
import classNames from 'classnames';
import { stringUtils } from '@indico-data/utils';
import { Button, Icon } from 'Permafrost/index';
import { StyledTeamTable } from './TeamTable.styles';
/**
 * List of users of a Dataset or Workflow. If an owner is specified, they will appear
 * first in the list, and will not be deletable.
 */
export function TeamTable(props) {
    const { className, id, labelledby, owner, removeUser, users } = props;
    const listItems = [];
    if (owner) {
        listItems.push(React.createElement("div", { key: owner.userId, className: "table-row" },
            React.createElement("div", null, owner.email),
            React.createElement("div", null, returnFormattedRole(owner.role))));
    }
    users.forEach((user) => listItems.push(React.createElement("div", { key: user.userId, className: classNames('table-row', user.rowClassName) },
        React.createElement("div", null, user.email),
        React.createElement("div", null, returnFormattedRole(user.role)),
        React.createElement("div", { title: "remove team member" },
            React.createElement(Button, { onClick: () => removeUser(user.userId), variant: "no-style", "aria-label": "remove team member" },
                React.createElement(Icon, { name: "trash", size: ['18px'] }))))));
    return (React.createElement(StyledTeamTable, { "aria-labelledby": labelledby, className: className, "data-cy": props['data-cy'], id: id, title: "", listHeader: React.createElement("div", { className: "table-row heading" },
            React.createElement("div", null, "Email"),
            React.createElement("div", null, "Role")), listItems: listItems }));
}
// ensures Role is nicely formatted in the UI
function returnFormattedRole(role) {
    if (!role)
        return '';
    return role === 'LABELER_AND_REVIEWER' ? 'Labeler & Reviewer' : stringUtils.capitalize(role);
}
//# sourceMappingURL=TeamTable.js.map